<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()">
      <img
        src="/assets/images/fsimage_20251025.png"
        height="40"
        alt="FX Infinity"
        class="logo-image"
      />
    </a>
  </div>
</div>

<div class="header-container">
  <nb-actions size="small">
    <nb-action
      class="control-item help-action"
      icon="question-mark-circle-outline"
      title="Help for this page"
      (click)="toggleHelp()"
    ></nb-action>
    <nb-action class="control-item" icon="email-outline"></nb-action>
    <nb-action class="control-item" icon="bell-outline"></nb-action>
    <nb-action
      class="user-action"
      *nbIsGranted="['view', 'user']"
      [nbContextMenu]="items"
      nbContextMenuTag="user-menu"
    >
      {{ user.name }}
    </nb-action>
  </nb-actions>
</div>
